import type { UnknownOutputParams } from 'expo-router'
import type { ReactNode } from 'react'

import { Header } from '@/src/elements/header'
import { Stack } from '@/src/elements/navigation/Stack'
import { ICON } from '@/src/general/enums/icons'
import { useBackHandlePress } from '@/src/general/hooks/useBackHandlePress'
import { useRoutes } from '@/src/general/utils/routes'

import { SettingsScreensProtectedNavigation } from '../components/SettingsScreensProtectedNavigation/SettingsScreensProtectedNavigation'

type TSettingsLayoutProps = {
  fallbackRoute?: string
  searchParams: UnknownOutputParams
}

export const SettingsLayout = ({ fallbackRoute, searchParams }: TSettingsLayoutProps): ReactNode => {
  const { routes } = useRoutes()
  const { handleBackPress } = useBackHandlePress(fallbackRoute || routes.settings())

  return (
    <SettingsScreensProtectedNavigation searchParams={searchParams}>
      <Stack
        screenOptions={{
          headerShown: true,
          animation: 'slide_from_right',
          header: ({ options }) => (
            <Header
              title={options.title}
              leftButtons={[{ type: 'icon', startIcon: ICON.ARROW_LEFT, onPress: handleBackPress }]}
              className="pr-16"
            />
          ),
        }}
      />
    </SettingsScreensProtectedNavigation>
  )
}
